module.exports = __webpack_public_path__ + "img/polygonBadge.4c4ceb49.svg";